// SideToggle — selector visual Long / Short.
// Long en verde (alcista), Short en rojo (bajista). Acentos brand quedan
// reservados para CTAs primarios; aquí queremos comunicación trader-style
// (verde sube, rojo baja) que es el lenguaje universal del mercado.

import type { ReactElement } from 'react';
import type { TradeSide } from '@bini-trading/shared-types';
import { cn } from '../../lib/cn';

interface Props {
  value: TradeSide;
  onChange: (v: TradeSide) => void;
}

export function SideToggle({ value, onChange }: Props): ReactElement {
  return (
    <div className="grid grid-cols-2 gap-2">
      <button
        type="button"
        onClick={() => onChange('long')}
        className={cn(
          'flex items-center justify-center gap-2 h-12 rounded-lg border font-semibold transition-all',
          value === 'long'
            ? 'bg-win-DEFAULT/15 border-win-DEFAULT text-win-DEFAULT shadow-[0_4px_14px_-4px_rgba(16,185,129,0.4)]'
            : 'bg-surface-elevated border-surface-border text-ink-muted hover:border-win-DEFAULT/40 hover:text-win-DEFAULT',
        )}
      >
        <span className="text-lg leading-none">↑</span>
        Long
      </button>
      <button
        type="button"
        onClick={() => onChange('short')}
        className={cn(
          'flex items-center justify-center gap-2 h-12 rounded-lg border font-semibold transition-all',
          value === 'short'
            ? 'bg-loss-DEFAULT/15 border-loss-DEFAULT text-loss-DEFAULT shadow-[0_4px_14px_-4px_rgba(239,68,68,0.4)]'
            : 'bg-surface-elevated border-surface-border text-ink-muted hover:border-loss-DEFAULT/40 hover:text-loss-DEFAULT',
        )}
      >
        <span className="text-lg leading-none">↓</span>
        Short
      </button>
    </div>
  );
}
